export const MODULES = {
    BigCommerce: 'bigcommerce_module',
    Ecwid: 'ecwid_module',
    Magento: 'magento_module',
    Prestashop: 'prestashop_module',
    Shopify: 'shopify_module',
    Shopware: 'shopware_module',
    Wix: 'wix_module',
    Woocommerce: 'woocommerce_module',
    Zencart: 'zencart_module',
};

export const OAUTH2_MODULES = { [MODULES.Shopify]: true };
